import React, { useEffect, useMemo, useState } from 'react';
import BlueInfoBox from '../../components/UI/BlueInfoBox/BlueInfoBox';
import FormAutoComplete from '../FormComponents/FormAutoComplete';
import FormElement from '../FormElement';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { useTranslation } from 'react-i18next';
import { isValue } from '../utils';

export function FormTags(props: ICommonFormProps) {
    const { t } = useTranslation();
    const [value, setValue] = useState<any[]>([]);
    const selectProps = props.formProps?.selectOptions;
    /**Select options manipulate the selected options to disabled */
    const selectOptions = useMemo(() => {
        if (selectProps && Array.isArray(selectProps)) {
            //@ts-ignore
            return selectProps.map((item: any) => {
                const index = value?.findIndex((values) => values.id === item.id)!;
                return {
                    ...item,
                    disabled: index > -1 ? true : false,
                };
            });
        }
    }, [selectProps, value]);

    useEffect(() => {
        function setDefaultValue() {
            if (props.value) {
                if (props.value?.oldTags && props.value?.newTags) {
                    //@ts-ignore
                    return [...new Set([...props.value.oldTags, ...props.value?.newTags])];
                }
                return props.value;
            }
            return [];
        }
        setValue(setDefaultValue());
        //eslint-disable-next-line
    }, [props.value]);

    function setValues(keyName: string, newValue: any[]) {
        const ignoreLength = value ? value.length > 0 : false;
        if (props.setValue && isValue(newValue, ignoreLength)) {
            props.setValue(props.keyName, newValue, { shouldDirty: true });
        }
        if (props.errors) {
            props.triggerValidation!(props.keyName);
        }
        setValue(newValue);
    }

    return (
        <div>
            <FormElement {...props}>
                <FormAutoComplete
                    {...props}
                    value={value}
                    formProps={{ ...props.formProps, selectOptions }}
                    keyName={props.keyName}
                    setValue={setValues}
                />
            </FormElement>
            {props?.formProps?.infoBoxTextLabel && (
                <div style={{ marginTop: '1rem' }}>
                    <BlueInfoBox fullWidth={true} Info={t(props?.formProps?.infoBoxTextLabel)} />{' '}
                </div>
            )}
        </div>
    );
}
